<template>
  <div>
    
    <div class="container text-primary product-change">
      <div class="h4 text-center p-2">Shopping Cart</div>
      <div class="d-flex justify-content-around p-5 text-primary  font-weight-bold ">
         <div>1.確認購買商品</div>
       <div >2.填寫運送資訊</div>
       <div>3.購物完成</div>
      </div>
        <table class="table table-rwd text-primary">
　<tr class="tr-only-hide">
　<th width="50"></th>
             　     <th  colspan="1" class="d-md-table-cell d-none text-center">商品資訊</th>
             <th width="100" class="d-md-table-cell d-none text-center">商品</th>
           
                 
            <th width="60" class="d-md-table-cell d-none text-center">數量</th>
            <th width="75" class="d-md-table-cell d-none text-center">單價</th>
             <th width="75" class="d-md-table-cell d-none text-center">折扣價</th>
            <th width="90 " class="text-center">小計</th>
            <th width="90" class="text-center">下次買</th>
　</tr>


<tbody class="text-primary">
           
             <tr v-for="(item) in CartData.carts" :key="item.id">
           <td class="align-middle text-left d-md-table-cell d-none "></td>
             

             
               <td class="" data-th="商品資訊">
                 <div
                  class="bg-cover"
                  :style="`background-image:url('${item.product.imageUrl}');width: 80%;height:180px;background-size:cover; background-repeat:no-repeat;`">
                  </div>
               
              </td>
               <td class="align-middle text-left d-md-table-cell d-none " data-th="商品" >
                <span class="text-primary ">{{item.product.title}}</span>
                 <div class="text-primary" v-if="item.coupon">
                  已套用優惠券
                </div>
              
              </td>
              <td class="align-middle  text-right" data-th="數量">
                <span>{{item.qty}}</span>
              </td>
              <td class="align-middle text-right" data-th="單價">
                <span>{{item.product.origin_price|currency}}</span>
              </td>
               <td class="align-middle text-right" data-th="折扣價" >
                <span class="text-muted" >{{CartData.final_total|currency}}</span>
              </td> 
              <td class="align-middle text-right" data-th="小計">
                <span>{{item.product.price * item.qty |currency}}</span>
              </td> 
                <td class="align-middle text-right"  data-th="下次買">
                <button type="button"
                  class="btn btn-outline-primary btn-sm border-0"  @click="removeCartItem(item.id)">
                  <i class="far fa-trash-alt"></i>
               
                </button>
              </td>
            
            </tr>
          </tbody>

</table>
        <hr>
        <div class="container">
        <div class="row">
      <div class="input-group col-md-6">
  
     
  </div>
  
  <div class="col-md-3 ml-md-auto text-primary">
      <div class="row justify-content-end">
   
    <div class=" ">還差{{1000-CartData.final_total}}就能達到免運門檻唷</div>
   </div>
    <div class="row justify-content-end p-2">
   <div class=" col-4 text-right">折扣價</div>
    <div class=" col-4 text-right">{{CartData.final_total|currency}}</div> 
    </div>

    <div class="row justify-content-end p-2">
   <div class=" col-4  text-right " >運費</div>
    <div class=" col-4 text-right" >$80</div>
   </div>
    <div class="row justify-content-end p-2">
   <div class=" col-4 text-right" >總計</div>
    <div class=" col-4 text-right"  v-if="CartData.final_total">{{CartData.final_total+80|currency}}</div>
   </div>
   
 </div>
</div>
 </div>
<hr>
  <div class=" container">
    <span class="col-md-3 ">訂購人資訊</span>
      <form class="col-md-4" @submit.prevent="createOrder">
      
        <div class="form-group">
          <label for="useremail">Email</label>
          <input type="email" class="form-control" name="email" id="useremail"
            v-validate="'required|email'"
            :class="{'is-invalid': errors.has('email')}"
            v-model="form.user.email" placeholder="請輸入 Email">
          <span class="text-danger" v-if="errors.has('email')">
            {{ errors.first('email') }}
          </span>
        </div>

         <div class="form-group">
          <label for="username">收件人姓名</label>
          <input type="text" class="form-control" name="name" id="username"
            :class="{'is-invalid': errors.has('name')}"
            v-model="form.user.name" v-validate="'required'" placeholder="輸入姓名">
          <span class="text-danger" v-if="errors.has('name')">姓名必須輸入</span>
        </div>
          <div class="form-group">
          <label for="usertel">收件人電話</label>
          <input type="tel" class="form-control" id="usertel"
            v-model="form.user.tel" placeholder="請輸入電話">
        </div>  
             <div class="form-group">
          <label for="useraddress">收件人地址</label>
          <input type="address" class="form-control" name="address"
           :class="{'is-invalid': errors.has('address')}"
            id="useraddress" v-model="form.user.address" v-validate="'required'"
            placeholder="請輸入地址">
          <span class="text-danger" v-if="errors.has('address')">地址欄位不得留空</span>
        </div>

        <div class="d-flex justify-content-center">
        <button class="btn btn-primary text-white mt-4 col-md-3  " @click.prevent="createOrder">
            <i class="fas fa-spinner fa-spin" v-if="status.isLoading"></i>下一步
          </button>
        </div> 
      </form>
    </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
data(){
    return{
     CartData: {
        carts: {
         
      }
      },
    form: {
        user: {
          name: '',
          email: '',
          tel: '',
          address: '',
        },
        message: '',
      },
      status: {
         isLoading: false, 
         currentProductId: "" 
         },
      Coupon_Code:"",
    };
},
methods:{
    getCartData() {
      const vm = this;
      let api = `${process.env.APIPATH}/api/${process.env.CUSTOMPATH}/cart`;
      vm.$http.get(api).then(response => {
       console.log("取得要購買商品：", response);
      vm.CartData = response.data.data;
      });
    },
    removeCartItem(id) {
      const vm = this;
      $(`#NavBarCart-${index}`).attr("disabled", true);
      vm.currentProductId = id;
      const api = `${process.env.APIPATH}/api/${process.env.CUSTOMPATH}/cart/${id}`;
      vm.$http.delete(api).then(response => {
        console.log("刪除購物車資料：", response);
        vm.$bus.$emit("reGetCart");
        vm.getCartData();
      });
    },
    addCouponCode(){
      const vm=this;
      vm.status.isLoading=true;
       const api = `${process.env.APIPATH}/api/${process.env.CUSTOMPATH}/coupon`;
       const code={
         code: vm.Coupon_Code
       };
       vm.$http.post(api,{data:code}).then(response=>{
         if(response.data.success){
            vm.CartData.final_total = response.data.data.final_total;
            vm.$bus.$emit("message:push", response.data.message, "success");
            vm.status.isLoading = false;
        }else{
            vm.$bus.$emit("message:push", response.data.message, "danger");
             vm.status.isLoading = false;
        }
      vm.getCartData();
       });
    },

    createOrder() {
      const vm = this;
      const url = `${process.env.APIPATH}/api/${process.env.CUSTOMPATH}/order`;
      const order = vm.form;
        this.$validator.validate().then((result) => {
        if(result){
          this.$http.post(url,{data:order}).then((response) => {
          console.log("訂單建立",response);
          if(response.data.success){
            vm.$router.push(`/customercheckout/${response.data.orderId}`);
          }
          vm.status.isLoading=false;
        });
        }else{
          console.log("欄位不完整");
        }
      });


    
    },
},
created(){
  this.getCartData();
}
};

</script>




// WEBPACK FOOTER //
// src/components/pages/Step2.vue